/* eslint-disable no-magic-numbers */
import { Device } from '../helpers/Device'
export const MAX_TARGETING_LENGTH = 40
export const SLUG_ATTRIBUTE = 'data-slug'
export const TABLET_WIDTH = 728
export const DFP_ID = '1030006'
export const desktopOffsetMultiplier = 2.5
export const mobileOffsetMultiplier = 2.9
export const offsetTest = false
export const timeoutTest = false
export const timeout = () => {
  if (Device.isMobile) {
    return 1800
  }
  if (Device.isTablet) {
    return 2100
  }

  return 1800 // desktop
}
export const lazyTimeout = () => {
  if (Device.isMobile) {
    return 1100
  }
  if (Device.isTablet) {
    return 1400
  }

  return 1200 // desktop
}
export const refreshTimeout = () => {
  if (Device.isMobile) {
    return 1700
  }
  if (Device.isTablet) {
    return 1500
  }

  return 1200 // desktop
}
export const DEFAULT_REFRESH_INTERVAL = 30 // seconds

enum CountryMap {
  UnitedStates = 'united states',
  ROW = 'rest of world'
}

enum OSMap {
  IOS = 'ios',
  android = 'android',
  desktop = 'desktop'
}

enum DeviceMap {
  mobile = 'phone',
  tablet = 'tablet',
  desktop = 'desktop'
}

type IFlooringMap = {
  [country in CountryMap]: { [device in DeviceMap]: { [OS in OSMap]: number } }
}

// Values of 0.50001 shouldn't theoretically be hit.
// They represent an error in lookups, or
// an abnormal combination.
const flooringMap: IFlooringMap = {
  [CountryMap.UnitedStates]: {
    [DeviceMap.desktop]: {
      [OSMap.IOS]: 0.50001,
      [OSMap.android]: 0.50001,
      [OSMap.desktop]: 0.78
    },
    [DeviceMap.mobile]: {
      [OSMap.IOS]: 0.29,
      [OSMap.android]: 0.67,
      [OSMap.desktop]: 0.50001
    },
    [DeviceMap.tablet]: {
      [OSMap.IOS]: 0.34,
      [OSMap.android]: 0.61,
      [OSMap.desktop]: 0.50001
    }
  },
  [CountryMap.ROW]: {
    [DeviceMap.desktop]: {
      [OSMap.IOS]: 0.50001,
      [OSMap.android]: 0.50001,
      [OSMap.desktop]: 0.45
    },
    [DeviceMap.mobile]: {
      [OSMap.IOS]: 0.18,
      [OSMap.android]: 0.23,
      [OSMap.desktop]: 0.50001
    },
    [DeviceMap.tablet]: {
      [OSMap.IOS]: 0.23,
      [OSMap.android]: 0.37,
      [OSMap.desktop]: 0.50001
    }
  }
}

export const DEFAULT_FLOOR = (flooring: IFlooringModel) => {
  if (!flooring) {
    return 0.50001
  }
  const { country, derivedDevice, derivedOS } = flooring

  if (!country || !derivedDevice || !derivedOS) {
    return 0.50001
  }

  const countryLookup =
    country === CountryMap.UnitedStates
      ? CountryMap.UnitedStates
      : CountryMap.ROW

  if (
    !flooringMap[countryLookup] ||
    !flooringMap[countryLookup][derivedDevice] ||
    !flooringMap[countryLookup][derivedDevice][derivedOS]
  ) {
    return 0.50001
  }

  return flooringMap[countryLookup][derivedDevice][derivedOS]
}

export const PENNY_PRECISION = 2
export const MAX_REFRESHES = 10
export const SLOT_RENDER_ATTR = 'data-slot-rendered'
export const BLACKLIST_ATTR = 'data-blacklist-'
export const BLACKLIST = 'blacklist'
export const ALL = 'all'
export const OUTSTREAM_FLOOR = 4.5
